module.exports = __webpack_public_path__ + "img/sq4m_feature_01.80297a53.jpg";